module.exports = __webpack_public_path__ + "img/bchsv.2a801a6d.svg";